<template>
    <!--流程申请-->
    <el-container style="width:100%">
        <el-header style="height:120px;">
            <el-form :inline="true" :model="fromWorkFlow" ref="fromWorkFlow" class="demo-form-inline">
                <el-row :gutter="13">
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-col>
                                <el-form-item :label="$t('pgCommon.WORK_FLOW_CAPTION')" prop="templateName">
                                    <td-input v-model="fromWorkFlow.templateName" :maxlength="100"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.PRODEFKEY')" prop="templateKey">
                                    <td-input v-model="fromWorkFlow.templateKey" :maxlength="100"></td-input>
                                </el-form-item>
                                <el-form-item>
                                    <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                                </el-form-item>
                            </el-col>
                        </div>
                    </td-permission>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                ref="fromWorkFlowList"
                :dataSource="tableData"
                :hasMutiSelect="false"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :rowKey="rowKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-leaveBill
                v-if="dialogLeaveBillVisible"
                :dialogLeaveBillVisible="dialogLeaveBillVisible"
                :editItem="editItem"
                :title="title"
                :sIdDisabled="sIdDisabled"
                :btnShow="btnShow"
                :groupElement="groupElement"
                @dialogLeaveBillClose="dialogLeaveBillClose"
                @dialogLeaveBillCloseOnly="dialogLeaveBillCloseOnly"
            ></dialog-leaveBill>
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogLeaveBill from './components/dealPage.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-leaveBill': dialogLeaveBill
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.initRegex(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            passkey: [],
            groupElement: {},
            hasReadShow: false,
            sIdDisabled: false,
            btnShow: false,
            dialogLeaveBillVisible: false,
            editItem: {
                templateKey: '',
                taskKey: '',
                processId: ''
            },
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            permissionsAdd: ['workflow:add'],
            permissionsEdit: ['workflow:edit'],
            permissionsView: ['workflow:view'],
            permissionsDel: ['workflow:del'],
            permissionsImport: ['workflow:import'],
            listNodeInfo: [],
            templateKey: '',
            multipleSelection: null,
            fromWorkFlow: { templateName: '', templateKey: '' },
            dialogUploadInfoVisible: false, // 是否显示dialog
            settingDialogVisible: false, //是否显示设置界面dialog
            templateParam: {},
            tableData: [], // 表格数据
            startTime: '', // 查询开始时间
            endTime: '', // 查询结束时间
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'deploymentId',
            // 初始化表格
            columns: [
                {
                    prop: 'templateKey',
                    label: 'pgCommon.PRODEFKEY',
                    align: 'left'
                },
                {
                    prop: 'templateName',
                    label: 'pgCommon.WORK_FLOW_CAPTION',
                    align: 'left'
                },
                {
                    prop: 'deploymentTime',
                    label: 'pgCommon.UPDATETIME',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('span', params.row.deploymentTime);
                    }
                },
                {
                    label: 'pgCommon.OPERATE',
                    align: 'center',
                    render: (createElement, params) => {
                        if (this.passkey.includes(params.row.templateKey) || params.row.suspensionState == '2') {
                            return [];
                        } else {
                            let operateList = [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.applyForProcess(params.row.templateName, params.row.templateKey, params.row.templateId, params.row.version);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.START_PROCESS')
                                )
                            ];
                            return operateList;
                        }
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        initRegex() {
            let params = {
                sTag: 'WORKFLOW_PASS_KEY'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                if (response.data.content.length > 0) {
                    for (let index in response.data.content) {
                        this.passkey.push(response.data.content[index].sCode);
                    }
                }
                this.btnQuery();
            });
        },
        // 流程模板生成流程
        applyForProcess(templateName, templateKey, templateId, version) {
            let param = {
                proDefKey: templateKey,
                applyUserId: sessionStorage.getItem('userId')
            };
            Api.startModel(param, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/WorkFlowProcessQuery/startModel', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                if (response.data.count == 1) {
                    this.groupElement.currPerson = sessionStorage.getItem('username');
                    this.editItem.templateKey = templateKey;
                    this.editItem.taskKey = response.data.content.taskKey;
                    this.editItem.processId = response.data.content.processId;
                    this.editItem.taskId = response.data.content.taskId;
                    this.editItem.proDefId = templateId;  //流程自生成的版本
                    this.editItem.version = version; //增加版本
                    this.title = templateName;
                    this.dialogLeaveBillVisible = true;
                    this.btnShow = true;
                    this.sIdDisabled = true;
                }
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            this.loading = true;
            let param = {
                templateName: this.fromWorkFlow.templateName,
                templateKey: this.fromWorkFlow.templateKey,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: true
            };
            Api.queryTemplate(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('templateManage/queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('templateManage/queryTemplate', response.data.message);
                    return;
                }
                this.loading = false;
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        // 关闭页面
        dialogLeaveBillClose() {
            this.dialogLeaveBillVisible = false;
            this.btnShow = false;
            this.queryList();
            if (this.sIdDisabled) {
                this.sIdDisabled = false;
                let param = {
                    proInsId: this.editItem.processId,
                    reason: '取消'
                };
                Api.deleteProIns(param, response => {
                    this.loading = false;
                    if (response.status !== this.$common.login.RESPONSE_STATUS) {
                        this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                        this.loading = false;
                        this.$log.error('WorkFlowProcessQuery/deleteProIns', response);
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.loading = false;
                        this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                        this.$log.error('WorkFlowProcessQuery/deleteProIns', response.data.message);
                        return;
                    }
                });
            }
        },
        dialogLeaveBillCloseOnly() {
            this.dialogLeaveBillVisible = false;
            this.btnShow = false;
            this.sIdDisabled = false;
            this.queryList();
        }
    }
};
</script>
